module.exports = __webpack_public_path__ + "img/icon-emote3.2d2dce72.svg";